import { supabase } from './supabase'
import { trackSignupCompleted } from './posthogEvents'

const NEW_USER_WINDOW_MS = 15 * 60 * 1000

function resolveSignupMethod(provider: string | undefined): 'google' | 'email' {
  if (provider === 'google') {
    return 'google'
  }
  return 'email'
}

export async function trackSignupCompletedIfNewUser(userId: string): Promise<void> {
  const { data, error } = await supabase.auth.getUser()
  if (error || !data.user || data.user.id !== userId) {
    return
  }

  const createdAt = new Date(data.user.created_at).getTime()
  if (Number.isNaN(createdAt) || Date.now() - createdAt > NEW_USER_WINDOW_MS) {
    return
  }

  const provider = data.user.app_metadata?.provider as string | undefined
  trackSignupCompleted(resolveSignupMethod(provider))
}
